<span
  nz-tooltip
  nzTooltipPlacement="top"
  [nzTooltipMouseEnterDelay]="0.5"
  [nzTooltipTitle]="'LOT_TRANSLATION.ICONS_TOOLTIPS.' + icon | translate"
>
  {{ 'LOT_TRANSLATION.ICONS.' + icon | translate }}
</span>
